export const environment = {
  production: true,
  mode: 'Production',
  BASE_URL: '',
};
